import { useEffect, useRef } from 'react';

// TODO: move to shared
export function usePrevious<T = any>(value: T): T | null {
  const ref = useRef<null | T>(null);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
